/** Public bunny mark (transparent SVG). */
export const bunnyLogoSrc = `${process.env.PUBLIC_URL}/bunny.svg`;
